import styled from '@emotion/styled';
import { GraphQLFormattedError } from 'graphql';
import { Children, ReactNode, Ref } from 'react';
import { Col as ReactGridSystemCol } from 'react-grid-system';
import Alert from '../../common/components/Alert';
import { Row } from '../../common/components/layout/Grid';
import convertBbcode from '../../common/utils/convertBbcode';

const Styled = {
  ScrollToWrapper: styled.div`
    padding-top: 40px;
  `,
  RatesTileWrapper: styled(ReactGridSystemCol)`
    margin-bottom: 25px;
  `,
};

type RateResultsProps = {
  errors?: ReadonlyArray<GraphQLFormattedError>;
  children?: ReactNode[];
  ref?: Ref<HTMLDivElement>;
};

function RateResults({ errors, children, ref }: RateResultsProps) {
  const results = Children.toArray(children);

  return (
    <Styled.ScrollToWrapper ref={ref}>
      {/* Only show errors when we don't have any results */}
      {(results === undefined || results.length === 0) && errors && errors.length > 0 && (
        <Alert variant="danger">{convertBbcode(errors[0].message)}</Alert>
      )}

      {results && (
        <Row>
          {results.map((result, index) => (
            <Styled.RatesTileWrapper
              // Using index here is fine because the results won't shuffle around

              key={index}
              md={12}
              lg={6}
            >
              {result}
            </Styled.RatesTileWrapper>
          ))}
        </Row>
      )}
    </Styled.ScrollToWrapper>
  );
}
export default RateResults;
